import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "method-options flex-col credit-method selected-payment" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_radio_button_group = _resolveComponent("radio-button-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_radio_button_group, {
      options: _ctx.cardOptions,
      modelValue: _ctx.selectedCard,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCard) = $event))
    }, null, 8, ["options", "modelValue"]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "new-card" }, [
      _createElementVNode("div", { class: "square" }, [
        _createElementVNode("div", { id: "payment-status-container" }),
        _createElementVNode("div", { id: "card-container" })
      ])
    ], -1))
  ]))
}